<template>
    <div>
        <div>
            <main class="layoutContent">
                <!-- Encabezado contenido principal -->
                <header class="page-header">
                    <div class="container pt-2">
                        <div class="row align-items-center justify-content-between">
                            <div class="col-auto pt-1">
                                <h3 class="page-header--title">Bienvenido,<br> {{ empleado }}</h3>
                                <p class="page-header--subtitle">Plan de Vacaciones</p>
                            </div>
                            <div class="col-sm-12 col-xl-7 pb-2" v-show="banner1>''">
                                <div class="card p-2">
                                    <p class="h1 page-header--title text-success">{{ banner1 }}</p>
                                    <p class="text-danger fs-3 font-weight-bold">{{ banner2 }}</p>
                                </div>
                            </div>
                            <div class="col-auto pt-3 pr-3">
                                <p class="text-white">{{ fecha }}</p>
                            </div>
                        </div>
                    </div>
                </header>
                <!-- Fin encabezado contenido principal -->

                <div class="cuerpo">
                    <router-view/>
                </div>
            </main>
        </div>
         <!-- Cuerpo contenido principal -->
        <div class="container content-body">
            <div class="row">
                <div class="col-xl-4 mb-4">
                    <router-link class="card lift h-100" to="/catalogo">
                    <!-- <a class="card lift h-100" href="/catalogo"> -->
                        <div class="card-body d-flex justify-content-center flex-column">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="mr-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-package feather-xl text-primary mb-3">
                                        <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
                                        <path
                                            d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                                        </path>
                                        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                        <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                    </svg>
                                    <h5>Catálogo</h5>
                                    <div class="small">Buscador de establecimientos por zona o tipo de
                                        establecimiento.</div>
                                </div>
                                <img :src="require('@/assets/css/img/illustrations/browser-catalog.svg')" style="width: 8rem" alt="..."/>
                            </div>
                        </div>
                    <!-- </a> -->
                    </router-link>
                </div>

                <div class="col-xl-4 mb-4">
                    <router-link class="card lift h-100" to="/normativas">
                        <div class="card-body d-flex justify-content-center flex-column">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="mr-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-book feather-xl text-secondary mb-3">
                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                                        <path
                                            d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z">
                                        </path>
                                    </svg>
                                    <h5>Normativas</h5>
                                    <div class="small">Documentación y normas generales de los diferentes planes
                                        de vacaciones.</div>
                                </div>
                                <img :src="require('@/assets/css/img/illustrations/normativas.svg')" style="width: 8rem" alt="..."/>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-xl-4 mb-4">
                    <a class="card lift h-100" href="#!">
                        <div class="card-body d-flex justify-content-center flex-column">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="mr-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-layout feather-xl text-green mb-3">
                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                        <line x1="3" y1="9" x2="21" y2="9"></line>
                                        <line x1="9" y1="21" x2="9" y2="9"></line>
                                    </svg>
                                    <h5>Teléfonos de contacto</h5>
                                    <div class="small">Teléfono 900 35 10 10<br></div>
                                </div>
                                <img :src="require('@/assets/css/img/illustrations/windows.svg')" style="width: 8rem" alt="..."/>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

            <div class="row">
                <!-- Bloque Información de interés-->
                <div class="col-xl-6 mb-2">
                    <div class="card h-100">
                        <div class="card-header">
                            Información de interés
                        </div>
                        <div class="card-body cuadroScroll">
                            <div class="timeline timeline-xs" v-for="A in noticias" :key="A.id">

                                <!-- Timeline Item 1-->
                                <div class="timeline-item">
                                    <div class="timeline-item-date">
                                        <div class="timeline-item-date-text">{{ $util.DS(A.fh) }}</div>
                                        <div class="timeline-item-date-indicator bg-green"></div>
                                    </div>
                                    <div class="timeline-item-content">
                                        <p class="font-weight-bold">{{ A.name }}</p>
                                        <p class="small"  v-show="A.anuncio>''">{{ A.anuncio }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Bloque Información de contacto -->
                <div class="col-xl-6 mb-2">
                    <div class="card h-100">
                        <div class="card-header">
                            Datos de contacto
                        </div>
                        <div class="card-body">
                            <div class="contact-direction mb-4">
                                <p class="font-weight-bold">Comisión de Fondos Sociales Interempresas</p>
                                <p>Lotus Notes: RRHH_RRSS_Fondos.Sociales</p>
                            </div>
                            <div class="contact-direction mb-4">
                                <p class="font-weight-bold">Dirección</p>
                                <!-- <p>Bruno Abúndez 48, 2ª Planta</p> -->
                                <p>C/ Pericles, 34 - 28011 Madrid</p>
                                <p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z" />
                                    </svg>
                                    <span class="pl-2">fondos.sociales@telefonica.com</span>
                                </p>
                                <p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        fill="currentColor" class="bi bi-telephone-fill" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                    </svg>
                                    <span class="pl-2">900 35 10 10</span>
                                    <!-- <span class="pl-2">915 55 84 00</span> -->
                                </p>
                                <!-- <p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        fill="currentColor" class="bi bi-printer-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
                                        <path
                                            d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                                    </svg>
                                    <span class="pl-2"> 917 70 17 82</span>
                                </p> -->
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!-- Fin Cuerpo contenido principal -->
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'cuenta',
    components: {
        //publicidad,
    },
    data() {
        return {
            submitted: false,
            message: 'Error',
        };
    },
    computed: {
        ...mapState(['auth','errores','cfg','noticias']),
        ...mapState('G',['url']),

        fecha() {
            //return "Viernes 5 de Febrero del 2021";
            return new Date().toLocaleDateString();
        },

        empleado() {
            //return this.cta.name;
            let n=this.cta.name.split(',')[1];
            if (n=='') n=this.cta.name;
            return n;
        },

        banner1() {
            return this.cfg.banner1;
        },

        banner2() {
            return this.cfg.banner2;
        },

        cta() {
            return this.auth.user;
        },
        admon() {
            return (this.cta.dep=='ADMON');
        },
        chk_selected() {
            return this.submitted && !this.reg.chk;
        }

    },
    methods: {
        ...mapMutations(['alerta','modal','showModal']),
        ...mapActions(['exec']),

        submit(evt) {
            evt.preventDefault();

            //controlar errores
            this.submitted=true;
            //enviar
            this.enviar();
        },
        async enviar() {

            var args=this.cta;
            args.token=this.auth.token;
            let r=await this.exec({api:'info_personal', arg: args });

            let msg=r.error ? r.datos : 'Datos Guardados correctamente';
            //this.$store.commit('modal','Información Personal',msg);
            this.modal({tit:"Información Personal", msg:msg});

            this.submitted=false;

            //this.$router.push('/');
        },
        //validar
        valida_dni() {
            let r=this.$util.validaCIF(this.auth.user.nif);
            if (!r) {
                this.$refs.dni.focus();
                alert('Invalido ' + r);
            }
        },

    },
}
</script>

<style scoped>

.cuadroScroll {
	height: 240px;
	width: 100%;
	border: 1px solid #ddd;
	background: #ffffff;
	overflow-y: scroll;
}

</style>
